/** CoStar.Api.FusionSearch.SearchIds.ResultSetType */
export var ResultSetType;
(function (ResultSetType) {
    ResultSetType[ResultSetType["None"] = 0] = "None";
    ResultSetType[ResultSetType["Property"] = 1] = "Property";
    ResultSetType[ResultSetType["LeaseComp"] = 7] = "LeaseComp";
    ResultSetType[ResultSetType["ForLease"] = 14] = "ForLease";
    ResultSetType[ResultSetType["ForSale"] = 15] = "ForSale";
    ResultSetType[ResultSetType["SaleComp"] = 16] = "SaleComp";
    ResultSetType[ResultSetType["Tenant"] = 17] = "Tenant";
    ResultSetType[ResultSetType["ShoppingCenter"] = 18] = "ShoppingCenter";
})(ResultSetType || (ResultSetType = {}));
